<template>
  <figure ref="entryElementRef">
    <div class="video relative" :class="{ 'source--youtube aspect-w-16 aspect-h-9': isYoutube || isOnedioVideo }">
      <EntryOnedioVideo v-if="isOnedioVideo" :entry="entry" />
      <RenderHtml v-else :html="videoHtml" :class="{ 'relative aspect-w-16 aspect-h-9': !isYoutube }" />
    </div>
    <!-- <pre v-if="!videoHtml" class="whitespace-pre-wrap text-xs border-red-500 border" v-text="entry" /> -->
    <figcaption v-if="entry.text.html">
      <RenderHtml :html="entry.text.html"></RenderHtml>
    </figcaption>
  </figure>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import RenderHtml from '@/modules/common/components/RenderHtml.vue';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import EntryOnedioVideo from '../../video/component/EntryOnedioVideo';
import ArticleCardEmbed from './ArticleCardEmbed.vue';

export default defineComponent({
  components: {
    LazyHydrate,
    ArticleCardEmbed,
    EntryOnedioVideo,
    RenderHtml,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isYoutube = computed(() => props.entry.videoData?.source === 'youtube');
    const isOnedioVideo = computed(() => props.entry.videoData?.source === 'onedio');

    const videoHtml = computed(() => {
      if (props.entry.videoData?.source === 'youtube' && !props.entry.videoData?.html && props.entry.videoData?.id) {
        return `<iframe class="video-embed" src="https://www.youtube.com/embed/${props.entry.videoData.id}" width="480" height="360" frameborder="0"></iframe>`;
      }
      return props.entry.videoData?.html;
    });

    // Event Click Handlers For Analytics
    const entryElementRef = ref();
    const { initiliazeEntryEvents } = useTracking();
    initiliazeEntryEvents(entryElementRef);

    return {
      isYoutube,
      isOnedioVideo,
      videoHtml,
      entryElementRef,
    };
  },
});
</script>

<style lang="scss">
@mixin full-width {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.video-embed {
  @include full-width();
}
.source--youtube {
  iframe {
    @include full-width();
  }
}
</style>
